import {
  CreateEmailTemplateInput,
  // CreateEmailTemplateInput,
  // GetAllEmailTemplateResponseSchema,
  GetQueryProps,
  SendTestEmailTemplateInput,
  UpdateEmailTemplateInput,
  UpdateEmailTemplateInputGlobalSetting,
  // UpdateEmailTemplateInput,
} from "shared";
import { axiosClient, fetchCall } from "utilz";
import axiosUploadCall from "utilz/axios-call";
import {
  apiErrorHandler,
  generateUrlString,
  getMspId,
  getQueryDataObject,
  // validateApiResponse,
} from "utilz/helpers";

export const getAllEmailTemplates = async ({
  perPageCount,
  pageNumber,
  sortColumn,
  sortDirection,
  filter,
  searchQuery,
}: GetQueryProps) => {
  try {
    const data = await getQueryDataObject({
      perPageCount,
      pageNumber,
      sortColumn,
      sortDirection,
      filter,
      searchQuery,
    });

    const url = await generateUrlString({
      baseUrl: "email/template",
      data,
    });

    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      // const result = validateApiResponse({
      //   response: response,
      //   schema: GetAllTicketsTemplateResponseSchema,
      // });
      return resData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

// export const getEmailTemplateById = async (templateId: string) => {
//   try {
//     const url = `v2/configuration/email_template/${templateId}`;

//     const response = await axiosClient.get(`${url}`);
//     const resData = response.data;
//     if (resData.success && resData.statusCode === 200) {
//       return resData.data;
//     }
//     throw response;
//   } catch (error: any) {
//     apiErrorHandler(error);
//   }
// };

export const createEmailTemplate = async (
  inputData: CreateEmailTemplateInput
) => {
  try {
    const url = "email/template";
    const response = await axiosClient.post(`${url}`, inputData);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const updateEmailTemplate = async (
  inputData: UpdateEmailTemplateInput
) => {
  try {
    const data = {
      subject: inputData.subject,
      html_body: inputData.html_body,
      signature_type: inputData.signature_type,
      signature_id: inputData.signature_id,
      global_config_status: inputData?.global_config_status,
      template_service_sub_type: inputData.template_service_sub_type,
      // id: inputData.id,
    };
    // console.log("qqqqqqqqq", data);
    // const url = `/v2/configuration/email_template/${inputData.id}`;
    // const url = `email/template/${inputData.mapping_id}`;
    const url = "v2/email/template";
    const response = await axiosClient.patch(`${url}`, data);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getEmailTemplateGlobalSettings = async () => {
  try {
    const url = "v1/global/email/config";
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const updateEmailTemplateGlobalSettings = async (
  inputData: UpdateEmailTemplateInputGlobalSetting
) => {
  try {
    const data = {
      template_header: inputData.template_header,
      template_footer: inputData.template_footer,
      signature_id: inputData.signature_id,
    };
    // const url = `/v2/configuration/email_template/${inputData.id}`;
    // const url = `global/email/config/${inputData.mapping_id}`;
    const url = "v1/global/email/config";
    const response = await axiosClient.patch(`${url}`, data);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

// v1/test/email/template/event
export const sendTestEmailTemplate = async (
  inputData: SendTestEmailTemplateInput
) => {
  try {
    const data = {
      templateType: inputData.templateType,
    };
    const url = "v1/test/email/template/event";
    const response = await axiosClient.post(`${url}`, data);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const uploadEmailTemplateAttachment = ({
  formData,
}: {
  formData: FormData;
}) => axiosUploadCall("/v1/email/template/file", formData);
